// Fixed api_maker platform header names (not tenant config — these never change per
// environment, unlike environment.ADMIN_PATH/INS/DB which are read from environment.ts).
export enum EHeaderName {
    INS = 'x-am-ins',
    DB = 'x-am-db',
    USER_PATH = 'x-am-user-path',
    AUTHORIZATION_APP = 'x-am-authorization',
    AUTHORIZATION_USER = 'x-am-user-authorization',
    CALLER_ID = 'x-caller-id',
}
